import { IQuickVideo } from 'lib/api/quickVideo/types';
import { useDeleteQuickVideoMutation } from 'lib/api/quickVideo/useDeleteQuickVideoMutation';
import { NewModal } from 'lib/components';
import { Gap } from 'lib/components/styles/layout';
import React from 'react';
import { Button } from 'react-covideo-common';

type DeleteModalProps = {
  quickVideo: IQuickVideo;
  onClose: () => void;
};

const DeleteQuickVideoModal = ({ quickVideo, onClose }: DeleteModalProps) => {
  const { mutateAsync: deleteQuickVideoMutation, isLoading: isDeleting } =
    useDeleteQuickVideoMutation({
      closeModalHandler: onClose,
    });
  const onDelete = async () => {
    await deleteQuickVideoMutation(quickVideo.quickVideoId);
  };
  return (
    <NewModal closeModal={onClose} headerText='Delete Quick Video'>
      <Gap flexDirection='column' gap='24px' alignItems='flex-start'>
        <div>
          {`Are you sure you want to delete the "${quickVideo.name}" Quick Video?`}
        </div>
        <Gap justifyContent='flex-end' width='100%'>
          <Button
            variant='secondary'
            disabled={isDeleting}
            onClick={onClose}
            text='Cancel'
          />
          <Button
            variant='destructive'
            disabled={isDeleting}
            onClick={onDelete}
            text='Delete'
          />
        </Gap>
      </Gap>
    </NewModal>
  );
};

export default DeleteQuickVideoModal;
